

















import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Overlay from "@share/common/Overlay.vue";
import MediaLibraryHeader from "@share/web-conferences/components/media-library/MediaLibraryHeader.vue";
import MediaUpload from "@share/web-conferences/components/media-library/media-upload/MediaUpload.vue";
import MediaGrid from "@share/web-conferences/components/media-library/media-table/MediaGrid.vue";
import {WebConferencesSlides} from "@api/models/WebСonferencesSlides";
import MediaLibrarySpinner from "@share/web-conferences/components/media-library/MediaLibrarySpinner.vue";
import {UploadSlidesService} from "@share/web-conferences/data/media-library/UploadSlidesService";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import {SlidesService} from "@share/web-conferences/data/media-library/SlidesService";
import {WebConferenceService} from "@share/web-conferences/data/WebConferenceService";
import {NoticeLevel} from "@service/components/toast/type/Enums";
import {ConvertingStatusObserver} from "@share/web-conferences/signal-r/slides/ConvertingStatusObserver";
import {SlidesUpdatedParam} from "@share/web-conferences/interfaces/signalr/SlidesUpdatedParam";
import {RenderingStatus} from "@api/enums/WebConferenceSlides/RenderingStatus";
import {clearAllBodyScrollLocks, disableBodyScroll} from "body-scroll-lock";
import {ArrayHelpers} from "@common/ArrayHelpers";

@Component({
    name: "MediaLibrary",
    components: {MediaLibrarySpinner, MediaGrid, MediaUpload, MediaLibraryHeader, Overlay }
})
export default class MediaLibrary extends Vue {
    @Prop({default: false}) isShown: boolean;
    @Prop({required: true}) webConferenceService: WebConferenceService;

    uploadService: UploadSlidesService | null = null;
    slidesService: SlidesService | null = null;
    convertingStatusObserver: ConvertingStatusObserver | null = null;
    filesList: Record<string, WebConferencesSlides> = {};
    isLoaded = false;
    loadingFiles: Record<string, SlidesUpdatedParam> = {};

    get listToShow() {
        return Object.values(this.filesList);
    }

    created() {
        this.uploadService = new UploadSlidesService(
            this.$repositories.get(RepositoryFabric.WEB_CONFERENCE_SLIDES),
            this.$repositories.get(RepositoryFabric.FILE),
            this.webConferenceService.schemaId,
            this.webConferenceService.objectId,
            this.$store
        );

        this.slidesService = new SlidesService(
            this.$repositories.get(RepositoryFabric.WEB_CONFERENCE_SLIDES),
            this.webConferenceService.schemaId,
            this.webConferenceService.objectId,
            this.$store
        )

        this.convertingStatusObserver = new ConvertingStatusObserver(
            this.$repositories.get(RepositoryFabric.REALTIME),
            this.webConferenceService.schemaId,
            this.webConferenceService.objectId,
            this.$store,
            this.statusChangedHandler
        )
    }

    @Watch('isShown')
    onIsShowChanged() {
        //@todo check if it is no breaking anything
        if (this.isShown) {
            disableBodyScroll(this.$el as HTMLElement);
            this.initList();
        }
        else {
            clearAllBodyScrollLocks();
        }
    }

    async initList() {
        this.filesList = ArrayHelpers.keyBy(await this.slidesService?.fetchList() as WebConferencesSlides[], 'id');
        await this.convertingStatusObserver?.connect();
        this.isLoaded = true;
    }

    onClose() {
        this.$emit('closeModal');
    }

    async onDelete(file: WebConferencesSlides) {
        const deleteResult = await this.slidesService?.delete(file.id);
        if (deleteResult) {
            this.$delete(this.filesList, file.id);
            // this.filesList = this.filesList.filter(item => item.id != file.id);
        }
        else {
            this.$store.dispatch('notice/submitNotice', {
                text: this.$t('web-conferences.media-library.errors.delete'),
                level: NoticeLevel.danger
            });
        }
    }

    onUploaded(slides: WebConferencesSlides) {
        this.$set(this.filesList, slides.id, slides);
        // this.filesList.push(slides);
    }

    async statusChangedHandler(update: SlidesUpdatedParam) {
        if (this.filesList[update.id] && update.renderingStatus != RenderingStatus.Completed) {
            this.filesList[update.id].renderingStatus = update.renderingStatus;
        }
        else {
            await this.loadNew(update);
        }
    }

    async loadNew(update: SlidesUpdatedParam) {
        if (this.loadingFiles[update.id]) {
            this.$set(this.loadingFiles, update.id, update);
            return;
        }

        const newSlidesInstance = await this.slidesService?.get(update.id);
        if (newSlidesInstance != null) {
            if (this.loadingFiles[update.id] && newSlidesInstance.renderingStatus != this.loadingFiles[update.id].renderingStatus) {
                this.$set(newSlidesInstance, 'renderingStatus', this.loadingFiles[update.id].renderingStatus);
            }

            this.$set(this.filesList, newSlidesInstance.id, newSlidesInstance);
        }

        this.$delete(this.loadingFiles, update.id);
    }

    beforeDestroy() {
        this.convertingStatusObserver?.disconnect();
    }
}
